export default "__VITE_ASSET__DEZyem54__"